import { render, staticRenderFns } from "./ComissaoControle.vue?vue&type=template&id=4e822f2f&scoped=true"
import script from "./ComissaoControle.vue?vue&type=script&lang=js"
export * from "./ComissaoControle.vue?vue&type=script&lang=js"
import style0 from "./ComissaoControle.vue?vue&type=style&index=0&id=4e822f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e822f2f",
  null
  
)

export default component.exports